import {
    CONFIG,
    ContextConfig,
    EVENT,
    EVENT_LATER,
    EventTrackingConfig,
    GET_API,
    PAGE,
    TrackingConfig,
    TrackingConsumable,
    WINDOW_KEY,
} from '../types';

declare namespace window {
    let __analyticsQueue;
}

function push(entry: TrackingConsumable): number {
    if (!window[WINDOW_KEY]) {
         window[WINDOW_KEY] = [];
    }
    return window[WINDOW_KEY].push(entry);
}

function getContextConfig(key: ContextConfig | string, value?: any): ContextConfig {
    if (typeof key === 'object') {
        return key;
    }
    return { [key]: value };
}

export default {
    trackPage,
    trackEvent,
    trackEventLater,
    setPageContext,
    getApi,
};

export function trackPage(config: TrackingConfig): number {
    return push([PAGE, config]);
}
export function trackEvent(config: EventTrackingConfig): number {
    return push([EVENT, config]);
}
export function trackEventLater(config: EventTrackingConfig): number {
    return push([EVENT_LATER, config]);
}
export function setPageContext(key: ContextConfig | string, value?: any): number {
    return push([CONFIG, getContextConfig(key, value)]);
}
export function getApi(callback: Function): number {
    return push([GET_API, callback]);
}
export function _getBeacons() {
    return window[WINDOW_KEY];
}
